module.exports = __webpack_public_path__ + "img/profil.9e91d6f0.svg";